export enum DncListStatus {
  CLEAN = "CLEAN",
  STATE_LISTED = "STATE_LISTED",
  NATIONAL_LISTED = "NATIONAL_LISTED",
  LITIGATOR = "LITIGATOR",
}
